var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"earch"},[_c('div',{staticClass:"earchimg"},[_c('div',{staticClass:"text"},[_c('p',[_vm._v("当年累计育秧量")]),_c('span',{staticClass:"span1"},[_vm._v(_vm._s(_vm.seedlingnum.thisYearOrderNum))]),_c('span',[_vm._v("盘")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }